import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Home from './pages/Home';

import urls, { homeUrl } from './urls';


const HomeRoute = () => {
  return (
    <Switch>
      <Route exact path={homeUrl()} component={Home} />
    </Switch>
  );
}

export const baseUrl = urls.base;

export default HomeRoute;
